<template>
    <div class="loginRoot">
            <div class="ldiv">
                <h1>淇泰门锁管理系统</h1>
                <div class="lug">
                    <div :class="isDl ? 'form' : 'form2'">
                        <el-form v-show="isDl" class="loginForm" label-position="left" label-width="80px" :model="form">
                            <el-form-item label="用户名">
                                <el-input id="input" placeholder="请输入账号" v-model="form.username" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="密码">
                                <el-input id="input" placeholder="请输入密码" type="password" show-password clearable v-model="form.password"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit()">登录</el-button>
                                <!-- <el-button type="info" @click="isDl = false">注册</el-button> -->
                            </el-form-item>
                        </el-form>
                        <el-form v-show="!isDl" class="loginForm" label-position="left" label-width="100px" :model="form">
                            <el-form-item label="用户名">
                                <el-input id="input" placeholder="请输入账号" v-model="form.username" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="密码">
                                <el-input id="input" placeholder="请输入密码" type="password" show-password v-model="form.password" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="确认密码">
                                <el-input id="input" placeholder="请再次输入密码" type="password" show-password v-model="form.password2" clearable></el-input>
                            </el-form-item>
                            <el-form-item>
                                <span class="yiyou" @click="isDl = true">已有账号直接登录</span>
                                <el-button type="primary" @click="handleAdd()">注册</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
    
    </div>
</template>
  
<script>
import {login} from "../../utils/apis"
import md5 from 'md5';
export default {
    data() {
        return {
            form: {
                username: "",
                password: "",
                yanzhengma: "",

                password2: "",
            },
            isDl: true
        };
    },
    methods: {
        async onSubmit() {
            if (this.form.username && this.form.password) {
                try {
                    const res = await login({
                        username: "debdh_" + this.form.username,
                        password: md5(this.form.password),
					});
                    if (!res.errcode) {
                        localStorage.setItem("access_token", res.access_token);
                        localStorage.setItem("CurUser", JSON.stringify({opId: 1, opName: "测试", userName: this.form.username}));
                        // localStorage.setItem("menus", JSON.stringify([
                        //     {
                        //         children: [{node: "102001", displayText: "用户管理", pictureIndex: "el-icon-user", tabText: "/Admin/User"}],
                        //         display: "block", displayText: "管理操作", node: "102",parentNode: "1", pictureIndex: "el-icon-menu"
                        //     },
                        //     {
                        //         children: [],
                        //         display: "block", displayText: "门锁列表", node: "103",parentNode: "1", pictureIndex: "el-icon-lock", tabText: "/Lock/Lock"
                        //     },
                        //     {
                        //         children: [],
                        //         display: "block", displayText: "分组列表", node: "104",parentNode: "1", pictureIndex: "el-icon-lock", tabText: "/Group/Group"
                        //     },
                        // ]));
                        this.$router.replace("/Lock/Lock");
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            } else {
                return false;
            }
        },
    },
    };
</script>

<style lang="scss">
.loginRoot {
    width: 100vw;
    height: 100%;
    position:  absolute;
    background-size: cover;
    background-image: url("../../assets/new/bg.jpg")
}
.ldiv {
    width: 500px;
    height: 100%;
    left: 50%;
    color: #03ECF1;
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    h1 {
        color: #03ECF1;
        font-size: 30px;
    }
}
.lug {
    margin-top: 20px;
}
.form {
    background-image: url("../../assets/new/borderall.png");
    background-size: cover;
    width: 480px;
    height: 400px;
    line-height: 400px;
    display: flex;
    align-items: center;
}
.form2 {
    background-image: url("../../assets/new/borderallre.png");
    background-size: cover;
    width: 480px;
    height: 582px;
    line-height: 582px;
    display: flex;
    align-items: center;
}
.loginForm {
    width: 70%;
    left: 15%;
    position: relative;
    .el-form-item__label {
        color: #03ECF1 !important;
        text-align: justify !important;
        text-align-last: justify !important;
    }
    #input {
        background: #113981 !important;
        height: 36px;
        color: white;
        font-size: 14px;
        border-top: 1px solid rgb(60, 123, 240); /* 上边框 */
        border-bottom: 1px solid rgb(60, 123, 240); /* 下边框 */
        border-left: none; /* 左边框去掉 */
        border-right: none; /* 右边框去掉 */
    }
    .asd .el-input {
        width: 60%;
    }
    .asd .el-form-item__content {
        display: flex;
    }
    .yzm {
        height: 36px;
        width: 33%;
        margin-left: 5%;
        display: inline-block;
        border: 1px solid #03ECF1;
        cursor: pointer;
    }
    
    .el-input::before {
        content: url('../../assets/new/input_left.png'); /* 左图像的路径 */
        position: absolute;
        top: 70%; /* 将图像垂直居中 */
        // left: -12px;
        transform: translateY(-50%); 
    }
    
    .el-input::after {
        content: url('../../assets/new/input_right.png'); /* 右图像的路径 */
        position: absolute;
        top: 70%; /* 将图像垂直居中 */
        right: 0;
        transform: translateY(-50%); 
    }
    
    
    .yiyou {
        margin-right: 10px;
        font-size: 12px;
        cursor: pointer;
    }
}
  </style>